import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { getConfig } from "../../config";
import { DOB_INPUT_DATE } from "../../constants";

dayjs.extend(customParseFormat);

type ParseCustomDateParams = {
  date: string;
  resultFormat?: string;
  initialFormat?: string;
};

export const formatToDefaultLocaleDate = (date?: string): string => {
  if (date) {
    const dayjsDate = dayjs(date, DOB_INPUT_DATE);
    const month = new Date(0, dayjsDate.month()).toLocaleString(getConfig().ISO_COUNTRY_CODE || "en-US", {
      month: "long",
    });
    return `${dayjsDate.date()} ${month} ${dayjsDate.year()}`;
  }
  return "";
};

export const parseCustomDate = ({
  date,
  resultFormat,
  initialFormat = DOB_INPUT_DATE,
}: ParseCustomDateParams): string => {
  if (dayjs(date, resultFormat, true).isValid()) {
    return date;
  }

  return dayjs(date, initialFormat).format(resultFormat);
};
